module.exports = __webpack_public_path__ + "static/media/Autolinker.cb9b16c1.woff2";